import { AxiosHeaders } from 'axios';

export const getAuthHeaders = (headers: AxiosHeaders, accessToken: string) => {
  return {
    ...headers,
    Authorization: `Bearer ${accessToken}`,
  };
};
